import { Injectable, Inject } from '@angular/core';
import { SESSION_KEYS } from 'src/app/dataModels/session-keys';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';

/**
 * SESSION STORAGE implemented using ngx-webstorage-service
 */
@Injectable({
  providedIn: 'root'
})
export class SessionService {
  /**
   * Inject dependency
   * @param sessionStorage instance of Session Stoage
   */
  constructor(@Inject(SESSION_STORAGE) private sessionStorage: StorageService) {}

  /**
   * Set Session data into the Session storage with a key
   * @param key key for the session storage
   * @param value value for the session storage
   */
  public setSessionData(key: string, value: any) {
    this.sessionStorage.set(key, value);
  }

  /**
   * get the data stored in the session with a key
   * @param key key of the session storage
   */
  public getSessionData(key: string): any {
    return this.sessionStorage.get(key);
  }

  /**
   * remove the data stored in the session for a key
   * @param key key of the session storage
   */
  public removeSessionData(key: string): any {
    return this.sessionStorage.remove(key);
  }

  /**
   * Clear entire session
   */
  public clearSession() {
    for (const prop in SESSION_KEYS) {
      if (SESSION_KEYS[prop]) {
        this.sessionStorage.remove(prop);
      }
    }
  }
}
